/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_CountryDto } from '../models/PagedResultDto_CountryDto';
import type { Wealthlane_CustomerService_Dtos_Country_CountryDto } from '../models/Wealthlane_CustomerService_Dtos_Country_CountryDto';
import type { Wealthlane_CustomerService_Dtos_Country_CreateUpdateCountryDto } from '../models/Wealthlane_CustomerService_Dtos_Country_CreateUpdateCountryDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CountryService {

    /**
     * @returns Wealthlane_CustomerService_Dtos_Country_CountryDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppCountryCountries(): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_Country_CountryDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/country/countries',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_CustomerService_Dtos_Country_CountryDto OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppCountry(
requestBody?: Wealthlane_CustomerService_Dtos_Country_CreateUpdateCountryDto,
): CancelablePromise<Wealthlane_CustomerService_Dtos_Country_CountryDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/country',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_CountryDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppCountry(
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_CountryDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/country',
            query: {
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @param requestBody 
     * @returns Wealthlane_CustomerService_Dtos_Country_CountryDto OK
     * @throws ApiError
     */
    public static putApiCustomerApiAppCountry(
id: string,
requestBody?: Wealthlane_CustomerService_Dtos_Country_CreateUpdateCountryDto,
): CancelablePromise<Wealthlane_CustomerService_Dtos_Country_CountryDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/customer/api/app/country/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiCustomerApiAppCountry(
id: string,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/customer/api/app/country/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_CustomerService_Dtos_Country_CountryDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppCountry1(
id: string,
): CancelablePromise<Wealthlane_CustomerService_Dtos_Country_CountryDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/country/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
